<template>
  <div>
    <a
      class="linkpdfdoc a11y-ocultar-imagen-link"
      :href="publicPath + link"
      download
      v-if="descargable"
    >
      <div class="imagen">
        <picture>
          <source
            :srcset="publicPath + imagen_lap"
            media="(min-width: 769px)"
          />
          <img :srcset="publicPath + imagen_cel" alt="" />
        </picture>
      </div>
      <div class="info">
        <p class="descripcion">
          {{ descripcion }}
        </p>
        <p class="nombre">
          {{ nombre }} <br />{{ peso
          }}<span class="icono icono-descargar imagen"></span>
        </p>
      </div>
    </a>
    <a class="linkpdfdoc a11y-ocultar-imagen-link" :href="link" target="_blank" rel="noopener" v-else>
      <div class="imagen">
        <picture>
          <source
            :srcset="publicPath + imagen_lap"
            media="(min-width: 769px)"
          />
          <img :srcset="publicPath + imagen_cel" alt="" />
        </picture>
      </div>
      <div class="info">
        <p class="descripcion">
          {{ descripcion }}
        </p>
        <p class="nombre">
          {{ nombre }} <span class="icono icono-atras imagen"></span>
        </p>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: "LinkPDF",
  props: {
    link: String,
    descripcion: String,
    nombre: String,
    imagen_lap: String,
    imagen_cel: String,
    peso: {
      type: String,
      default: "",
    },
    descargable: {
      type: Boolean,
      default: false,
    },
  },
  methods: {},
  data() {
    return {
      publicPath: process.env.BASE_URL,
    };
  },
  computed: {},
};
</script>

<style scoped lang="scss">
a:hover, .link:hover{
        background: transparent;
        color: #fff;
        text-decoration: none;
    }
.linkpdfdoc {
  display: block;
  .imagen {
    border: 1px solid transparent;
    border-radius: 8px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    overflow: hidden;
    transition: all 0.2s ease-in-out;
    img {
      float: left;
    }
  }
  .info {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding-left: $gap * 0.5;
    margin-top: 16px;
    color:#141414;

    .descripcion {
      flex: 1;
      margin-top: 0;
      transition: all 0.2s ease-in-out;
    }
    .nombre {
      font-size: 14px;
      margin: 0 0 5px;
      flex: 0 1;
      font-weight: bold;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-radius: 0;
      padding-bottom: 15px;
      border-bottom: 1px solid #ccc;
      transition: all 0.2s ease-in-out;
      &:hover,
      &:focus{
        border-bottom: 7px solid #D13560;
        .icono{
          color:#fff;
          background-color:#D13560;
        }
      }
      .icono {
        background: #ddd;
        height: 30px;
        font-size: 30px;
        line-height: 30px;
        width: 30px;
        border-radius: 30px;
        text-align: center;
        font-weight: 400;
        display: inline-block;
        transition: all 0.2s ease-in-out;
        color:#141414;
        &.icono-atras {
          transform: rotate(180deg);
        }
      }
    }
  }
  @media (min-width: map-get($media-queries-limit, "mobile")) {
    display: flex;
    .info {
      flex: 1 0 calc(60% - $gap);
      max-width: calc(60% - $gap);
      display: flex;
      flex-direction: column;
      padding-left: $gap * 0.5;
      margin-top: 0;
    }
    &:hover,
    &:focus {
      background: #fff;
      color: #141414;
      }
    }
  }

</style>
